
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Kandivalitopunecab() {



    const cardData =
    {
        keyword: 'Kandivali to Pune Cab',
        heading: 'Skyline Cabs: Kandivali to Pune Cab',
        headingDescription: 'Skyline Cabs provides dependable and comfortable Kandivali to Pune Cab services for a smooth intercity journey. Whether you are heading to Pune for business, leisure, or airport transfers, our clean, well-maintained vehicles and experienced drivers ensure a safe and timely ride. With flexible booking options, transparent fares, and 24/7 customer support, Skyline Cabs makes travel from Goregaon to Pune easy and stress-free. Book your cab today and experience the comfort and reliability of Skyline Cabs.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Kandivali to Pune Cab Fare",
      "description": "Skyline Cabs offers reliable and affordable taxi services from Kandivali to Pune. Enjoy a smooth ride with competitive pricing and various vehicle options such as Innova Crysta, Ertiga, and sedans."
    },
    {
      "name": "Kandivali to Pune Station Cab Fare",
      "description": "Book a cab from Kandivali to Pune Station with Skyline Cabs for a comfortable and timely journey. Our transparent pricing ensures no hidden fees, and our experienced drivers guarantee a safe trip."
    },
    {
      "name": "Kandivali to Pune Pimpri Chinchwad Cab Fare",
      "description": "Travel conveniently from Kandivali to Pimpri Chinchwad with Skyline Cabs. We offer affordable pricing with various vehicle options including SUVs, sedans, and premium cars like Innova Crysta."
    },
    {
      "name": "Kandivali to Baner Taxi Fare",
      "description": "Skyline Cabs offers competitive rates for taxis from Kandivali to Baner. Whether you’re traveling for business or leisure, we provide a variety of vehicles to suit your needs."
    },
    {
      "name": "Kandivali to Pune by Taxi",
      "description": "Enjoy a hassle-free and comfortable ride from Kandivali to Pune with Skyline Cabs. We provide a wide range of vehicles, including Innova Crysta and Ertiga, ensuring a pleasant experience."
    },
    {
      "name": "Kandivali to Pune One Way Taxi Fare",
      "description": "Skyline Cabs offers affordable one-way taxi services from Kandivali to Pune. Choose from a variety of vehicles and experience seamless travel with fixed pricing."
    },
    {
      "name": "Kandivali to Pune Kondhwa Taxi",
      "description": "Skyline Cabs provides reliable taxi services from Kandivali to Kondhwa. Whether you're traveling for work or leisure, we offer multiple vehicle options to meet your travel requirements."
    },
    {
      "name": "Kandivali to Pune Innova Crysta Cab",
      "description": "Book an Innova Crysta for your ride from Kandivali to Pune with Skyline Cabs. Ideal for a comfortable and spacious journey, this premium vehicle is perfect for both individuals and groups."
    },
    {
      "name": "Kandivali to Pune Kharadi Cab",
      "description": "Skyline Cabs offers reliable taxi services from Kandivali to Kharadi, Pune. Choose from a range of vehicles for a smooth and efficient journey at affordable rates."
    },
    {
      "name": "Kandivali to Swargate Cab",
      "description": "Book a cab from Kandivali to Swargate with Skyline Cabs. We provide a range of vehicles, including SUVs and sedans, ensuring a comfortable ride for all passengers."
    },
    {
      "name": "Taxi Service in Kandivali Mumbai",
      "description": "Skyline Cabs provides dependable and affordable taxi services in Kandivali, Mumbai. Whether you need a local or outstation ride, we have a fleet of well-maintained vehicles to choose from."
    },
    {
      "name": "Kandivali to Pune Ertiga Taxi Fare",
      "description": "Skyline Cabs offers affordable Ertiga taxi services from Kandivali to Pune. Perfect for small groups or families, the Ertiga offers a comfortable ride at competitive prices."
    },
    {
      "name": "Mumbai to Pune Taxi Fare",
      "description": "Skyline Cabs provides affordable taxi services from Mumbai to Pune with transparent pricing. Enjoy a comfortable ride with a variety of vehicle options to suit your needs."
    },
    {
      "name": "Mumbai to Pune Car Rental",
      "description": "Skyline Cabs offers car rental services from Mumbai to Pune. Choose from a range of vehicles, including luxury options and SUVs, for a comfortable and stylish journey."
    },
    {
      "name": "Mumbai to Pune Cab Charges",
      "description": "Skyline Cabs offers competitive and transparent pricing for taxi services from Mumbai to Pune. Our pricing includes tolls, fuel, and driver charges, ensuring no hidden costs."
    },
    {
      "name": "Mumbai to Pune Cab Fare",
      "description": "Book a reliable taxi from Mumbai to Pune with Skyline Cabs. Our fares are competitive, and we offer a variety of vehicle options for both comfort and affordability."
    },
    {
      "name": "Mumbai to Pune Cab Booking",
      "description": "Book your Mumbai to Pune cab with Skyline Cabs for a smooth and safe journey. We offer a range of vehicle options, including luxury cabs and standard sedans."
    },
    {
      "name": "Cab Service in Mumbai",
      "description": "Skyline Cabs offers dependable and affordable cab services across Mumbai, including outstation trips, airport transfers, and local travel. We ensure prompt service and a hassle-free experience."
    },
    {
      "name": "Cab Booking Mumbai",
      "description": "Skyline Cabs provides easy online booking for all your taxi needs in Mumbai. Whether it's a local ride or outstation journey, book your cab with ease through our website or mobile app."
    },
    {
      "name": "Mumbai Taxi Service",
      "description": "Skyline Cabs offers professional and affordable taxi services in Mumbai. Choose from a variety of vehicle options to suit your needs, whether you're traveling locally or heading out of the city."
    },
    {
      "name": "Cheapest Cab Service in Mumbai",
      "description": "Skyline Cabs provides the most affordable taxi services in Mumbai without compromising on quality. Book your ride online and enjoy low fares with top-rated service."
    },
    {
      "name": "Taxi Service in Kandivali",
      "description": "Skyline Cabs offers reliable taxi services in Kandivali, Mumbai, for local, outstation, and airport transfers. Our fleet includes a wide range of vehicles to suit all travel needs."
    },
    {
      "name": "Cab Service in Kandivali",
      "description": "Skyline Cabs offers efficient and affordable cab services in Kandivali, Mumbai. Whether you're heading outstation or need a local taxi, we’ve got you covered with timely service."
    },
    {
      "name": "Cab Service in Kharghar",
      "description": "Skyline Cabs provides dependable cab services in Kharghar for both local and outstation trips. Book a cab online or by phone for a comfortable and safe journey."
    },
    {
      "name": "Taxi Service in Kandivali",
      "description": "Skyline Cabs offers top-notch taxi services in Kandivali, Mumbai. Our fleet includes a range of vehicles, including sedans, SUVs, and luxury cars for your convenience."
    },
    {
      "name": "Kandivali to Outstation Cab Service",
      "description": "Skyline Cabs offers convenient outstation taxi services from Kandivali. Whether you’re traveling to Pune, Lonavala, or any other destination, we offer comfortable and reliable rides."
    }
  ],
  "tableData": [
    ["Kandivali to Pune Cab Fare", "Kandivali to Pune Station Cab Fare"],
    ["Kandivali to Pune Pimpri Chinchwad Cab Fare", "Kandivali to Baner Taxi Fare"],
    ["Kandivali to Pune by Taxi", "Kandivali to Pune One Way Taxi Fare"],
    ["Kandivali to Pune Kondhwa Taxi", "Kandivali to Pune Innova Crysta Cab"],
    ["Kandivali to Pune Kharadi Cab", "Kandivali to Swargate Cab"],
    ["Taxi Service in Kandivali Mumbai", "Kandivali to Pune Ertiga Taxi Fare"],
    ["Mumbai to Pune Taxi Fare", "Mumbai to Pune Car Rental"],
    ["Mumbai to Pune Cab Charges", "Mumbai to Pune Cab Fare"],
    ["Mumbai to Pune Cab Booking", "Cab Service in Mumbai"],
    ["Cab Booking Mumbai", "Mumbai Taxi Service"],
    ["Cheapest Cab Service in Mumbai", "Taxi Service in Kandivali"],
    ["Cab Service in Kandivali", "Cab Service in Kharghar"],
    ["Taxi Service in Kandivali", "Kandivali to Outstation Cab Service"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Kandivali to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs provides reliable and punctual cab services for your journey from Kandivali to Pune. Whether you’re traveling for business, leisure, or any other purpose, we ensure a comfortable and stress-free ride every time."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Our fleet includes a range of comfortable vehicles, from sedans to spacious SUVs, designed to make your journey from Kandivali to Pune enjoyable. With air-conditioning, ample legroom, and smooth rides, you’ll feel at ease no matter the distance."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Our drivers are experienced and well-trained, with deep knowledge of the best routes from Kandivali to Pune. They prioritize safety, punctuality, and comfort, ensuring that you have a smooth and pleasant journey from start to finish."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Skyline Cabs offers competitive pricing for your Kandivali to Pune trip, with no hidden charges. You’ll receive an upfront quote for your journey, so there are no surprises along the way. Enjoy reliable service at an affordable rate."
    },
    {
        "WhyChooseheading": "24/7 Availability for Anytime Travel",
        "WhyChoosedescription": "Whether you need a ride early in the morning, in the middle of the day, or late at night, Skyline Cabs is available 24/7. You can easily book your cab at any time, ensuring flexibility in your travel plans."
    },
    {
        "WhyChooseheading": "Easy Online Booking and Instant Confirmation",
        "WhyChoosedescription": "Booking your Kandivali to Pune cab is easy and quick with Skyline Cabs. Simply use our website or mobile app to book your ride in a few clicks. You’ll receive instant booking confirmation, making your trip planning as smooth as the ride itself."
    },
    {
        "WhyChooseheading": "Safe and Sanitized Rides Every Time",
        "WhyChoosedescription": "Your safety and hygiene are our priority. All of our vehicles are thoroughly cleaned and sanitized after each ride, and our drivers follow strict safety protocols. Enjoy a clean, secure, and safe ride from Kandivali to Pune."
    },
    {
        "WhyChooseheading": "Flexible Vehicle Options for Every Group Size",
        "WhyChoosedescription": "No matter how many people you’re traveling with, we have a vehicle that fits your needs. From solo travelers to families or small groups, Skyline Cabs offers a variety of vehicles to ensure your Kandivali to Pune journey is comfortable and convenient."
    }
]

























    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Kandivali to Pune with Skyline Cabs?',
            answer:
                'Booking a cab from Kandivali to Pune is quick and easy. Simply visit our website or use our mobile app to enter your pickup location and destination, choose your preferred vehicle, and confirm the booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Kandivali to Pune trip?',
            answer:
                'We offer a variety of vehicles including Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. Choose a vehicle based on your preferences for comfort and the number of passengers.',
        },
        {
            id: 3,
            question: 'How long does it take to travel from Kandivali to Pune?',
            answer:
                'The travel time from Kandivali to Pune is approximately 3.5 to 5 hours, depending on traffic conditions. Our experienced drivers take the best routes to ensure a smooth and timely journey.',
        },
        {
            id: 4,
            question: 'Are the fares for the Kandivali to Pune cab fixed?',
            answer:
                'Yes, the fare is fixed and includes all costs such as tolls, taxes, and driver charges. You’ll know the total cost upfront before confirming your booking, ensuring transparency.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab service from Kandivali to Pune?',
            answer:
                'Yes, you can easily book a round-trip cab. Simply provide your return journey details while making the booking, and we’ll ensure a seamless travel experience for both trips.',
        },
        {
            id: 6,
            question: 'Is it possible to book a cab for a group from Kandivali to Pune?',
            answer:
                'Yes, we can accommodate larger groups with spacious vehicles like SUVs and minivans. Let us know your requirements during booking, and we’ll arrange the best option for your group.',
        },
        {
            id: 7,
            question: 'Are the vehicles for the Kandivali to Pune journey well-maintained?',
            answer:
                'Absolutely! All our vehicles are well-maintained and thoroughly cleaned before every trip. We prioritize safety and comfort, ensuring you enjoy a hassle-free ride.',
        },
        {
            id: 8,
            question: 'Can I make an online payment for my Kandivali to Pune cab?',
            answer:
                'Yes, we offer secure online payment options such as credit/debit cards, UPI, and net banking. You can also pay in cash if preferred.',
        },
        {
            id: 9,
            question: 'Is there a customer support team for assistance with my Kandivali to Pune cab booking?',
            answer:
                'Yes, our customer support team is available 24/7 to assist with bookings, changes, or any queries regarding your trip from Kandivali to Pune.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for my Kandivali to Pune trip?',
            answer:
                'Skyline Cabs offers reliable, comfortable, and affordable transportation with professional drivers, well-maintained vehicles, and transparent pricing for a stress-free journey.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Rahul Desai",
            rating: 5,
            review: "Booked a cab from Kandivali to Pune for a business trip. The entire experience was smooth. The driver was punctual, the vehicle was clean and comfortable, and I reached on time. Highly recommended service!"
        },
        {
            name: "Miss. Priya Mehta",
            rating: 4,
            review: "I traveled from Kandivali to Pune for a weekend getaway. The booking process was seamless, and the ride was very comfortable. The driver was professional, and I felt safe throughout the trip. Will use Skyline Cabs again."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


 const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Kandivali to Pune Cabs",
  "image": "https://skylinecabs.com/assets/images/kandivali-to-pune-cab.jpg",
  "description": "Book Kandivali to Pune cabs with Skyline Cabs for safe, comfortable, and timely travel. Choose from AC sedans or SUVs with professional drivers — available 24/7 for one-way or round-trip bookings.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7398"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1300",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/kandivali-to-pune-cabs"
  }
};



      
      
      


    return (
        <div>
            
<Helmet>
  <title>Kandivali to Pune Cabs | 24/7 AC Taxi Booking | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Kandivali to Pune cabs with Skyline Cabs for safe, comfortable, and timely travel. Choose from AC sedans or SUVs with professional drivers — available 24/7 for one-way or round-trip bookings." 
  />
  <meta 
    name="keywords" 
    content="Kandivali to Pune Cabs, Cab from Kandivali to Pune, One-Way Taxi Kandivali to Pune, Round Trip Cab Kandivali to Pune, AC Cab Kandivali to Pune, SUV Taxi Kandivali to Pune, Affordable Taxi Kandivali to Pune, Online Cab Booking Kandivali Pune, Skyline Cabs Kandivali to Pune, 24/7 Taxi Service Kandivali to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/44.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Kandivalitopunecab;